import './savingsAccountsOffersView.scss';

// vendors
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { i18n } from 'core/i18n';
import PropTypes from 'prop-types';
// components
import { OKCover } from 'commonsComponents/OKCover';
import SavingsAccountsOffersViewError from './components/savingsAccountsOffersViewError/savingsAccountsOffersViewError';
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import { LoadingSection } from 'commonsComponents/loadingSection';
import SavingsAccountsOffersViewAccordeon from './components/savingsAccountsOffersViewAccordeon/savingsAccountsOffersViewAccordeon';
import SavingsAccountsOffersViewOffersList from './components/savingsAccountsOffersViewOffersList/savingsAccountsOffersViewOffersList';
import { useFetchGenericOffers } from '../../components/offers/hooks/useFetchAccountOffers';
// actions
import offersActions from 'actions/offersActions';
//utilities
import { savingsAccountsLandingAdapter } from '../../components/offers/adapters/savingsAccountsLandingAdapter';
import { getIsFullProfitability } from '../../utilities/depositHelper';
const { formatText, FormattedTextWithNamedVariables, getLanguage, getNamedVariables } = i18n;



const SavingsAccountsOffersView = ({ immAccounts, immOffers, fetchOffers, originCountry, history }) => {
    const breadcrumb = useMemo(() => [
        {
            text: formatText('breadcrumb-accounts'),
            url: '/myprofile/accounts'
        },
        {
            text: formatText('savingsAccounts-savingsAccounts_savingsAccount'),
            url: ''
        }
    ], []);
    
    const handleFetchOffers = () => {
        fetchOffers({
            flow: "SAVINGS_CC_OFFERS_LANDING",
            metadata: {
                language: getLanguage().toUpperCase()
            }
        });
    };

    const getStaticRepresentativeExample = (examples) => {
        return examples.map((exampleObject) => {
            const { superIndex, example, accountConfig } = exampleObject;
            const exampleNamedValues = getNamedVariables(example, { ...accountConfig, superIndex });
            return (
                <li key={superIndex}>
                    <FormattedTextWithNamedVariables value={example} namedVariables={exampleNamedValues} />
                </li>
            )
        })
    };
    
    const {
        parsedOffers,
        error,
        loading,
        refetchOffers
    } = useFetchGenericOffers({ adapter: savingsAccountsLandingAdapter, requestOffers: handleFetchOffers, immOffers, originCountry });

    if (loading) {
        return <LoadingSection />;
    }

    return (
        <article className="savings-accounts-offers-view">
            <header className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="accounts" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={breadcrumb}
                            finalTitle={formatText('savingsAccounts-savingsAccounts_savingsAccount')}
                        />
                    </OKCover>
                </div>
            </header>
            <section className="grid-view__body grid-view__body--cc">
                <div className="row">
                    <div className="col-xs-12">
                        <SavingsAccountsOffersViewAccordeon immAccounts={immAccounts} />
                        {error && <SavingsAccountsOffersViewError onButtonClick={refetchOffers} />}
                        {
                            parsedOffers?.offers ?
                                <SavingsAccountsOffersViewOffersList
                                    offers={parsedOffers}
                                    isFullRates={getIsFullProfitability(originCountry)}
                                    history={history}
                                />
                                : null
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        {
                            parsedOffers?.examples ?
                                <ul className="savings-accounts-offers-view__examples">
                                    {getStaticRepresentativeExample(parsedOffers.examples)}
                                </ul> : null
                        }
                    </div>
                </div>
            </section>
        </article>
    );
};

SavingsAccountsOffersView.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immOffers: PropTypes.object.isRequired,
    fetchOffers: PropTypes.func.isRequired,
    originCountry: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
};


module.exports.SavingsAccountsOffersView = connect(
    (state) => ({
        immAccounts: state.accounts,
        immOffers: state.offers,
        originCountry: state.profile.get('originCountry'),
    }),
    {
        fetchOffers: offersActions.fetchOffers2,
    }
)(withRouter(SavingsAccountsOffersView));
